import React from "react";
import AboutComp from "./AboutComp";

const AboutComp2 = ({data}) => {
  return (
    <div className="w-[95vw] h-[100%] rounded-[10px]  border-solid border-[1px] border-black  ">
      <AboutComp
        heading="About"
        content={data}
      />
    </div>
  );
};

export default AboutComp2;
